import { APP } from 'src/Configs/App'
import { ANY_LANGUAGE_ID, NO_VOCAL } from 'src/Constants/constants'
import { capitalize } from 'src/Helpers/layoutHelpers'
import { rtkApi } from 'src/Services/rtkApi'
import { GroupedOption } from 'src/Types/tracks'

interface LanguageResponseItem {
  id: number
  languageName: string
  playlistsCount?: number
}

export interface PlaylistsLanguagesResponse {
  popular: LanguageResponseItem[]

  other: LanguageResponseItem[]
}

interface LanguageItem {
  id: number
  language_name: string
  playlists_count?: number
}

const toLanguageItem = (item: LanguageResponseItem): LanguageItem => ({
  id: item.id,
  language_name: item.languageName,
  playlists_count: item.playlistsCount,
})

const languagesApi = rtkApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllLanguages: builder.query<LanguageItem[], void | null>({
      query: () => `${APP.TIKTOK_SERVER}/curator/languages`,
      transformResponse: (response: LanguageResponseItem[]) => {
        const languagesFiltered = response
          .map(toLanguageItem)
          .filter((el) => el.id !== 1)
        const elementsToMove = languagesFiltered.filter(
          (el) => el.id === NO_VOCAL || el.id === ANY_LANGUAGE_ID,
        )
        const elementsRest = languagesFiltered.filter(
          (el) => el.id !== NO_VOCAL && el.id !== ANY_LANGUAGE_ID,
        )
        return [...elementsToMove, ...elementsRest]
      },
    }),
    getLanguagesForExistingPlaylists: builder.query<
      GroupedOption[],
      void | null
    >({
      query: () => `${APP.TIKTOK_SERVER}/artist/languages/with-playlist-stats`,
      transformResponse: (response: PlaylistsLanguagesResponse) => {
        const getLabel = (item: LanguageResponseItem): string =>
          item.id === NO_VOCAL
            ? 'Instrumental'
            : capitalize(item.languageName || '')
        return [
          {
            label: 'Most popular',
            options: (response?.popular || []).map((item) => ({
              value: item.id,
              label: getLabel(item),
            })),
          },
          {
            label: 'A-Z',
            options: (response?.other || [])
              .map((item) => ({
                value: item.id,
                label: getLabel(item),
              }))
              .filter((item) => item.value !== ANY_LANGUAGE_ID),
          },
        ]
      },
    }),
  }),
  overrideExisting: false,
})

export const {
  useGetAllLanguagesQuery,
  useGetLanguagesForExistingPlaylistsQuery,
} = languagesApi
